import '../styles/App.css';
import 'leaflet/dist/leaflet.css';


function App() {
  return (
    <div>
      <h1 className="p-10 text-5xl font-bold text-blue-600 text-center">Welcome to FishFind!</h1>
      <h1 className="text-2xl text-gray-200 text-center">
        FishFind is a website where you can find fish from reports by other users on a map!
        <br></br>
        Try logging in to upload your own pin with a photo!
      </h1>
    </div>
  );
}

export default App;
